export default __webpack_public_path__ + "static/media/mlodz5.edcc1340.jpg";